import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../context/tenant-context';
import { v2Component } from '../../index';
import { CustomerOrderList } from './customer-order-list';
import { ViewCustomerOrder } from './view-customer-order';
import { CustomerContextProvider } from '../../context/customer-context';

export function initCustomerOrders() {
  document.getElementsByName('customer-order-list').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');

      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <CustomerContextProvider>
              <CustomerOrderList />
            </CustomerContextProvider>
          </TenantContext.Provider>,
        ),
      );
    }
  });

  document.getElementsByName('view-customer-order').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');

      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, orderId, payInvoice } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <CustomerContextProvider>
              <ViewCustomerOrder orderId={orderId} payInvoice={payInvoice} />
            </CustomerContextProvider>
          </TenantContext.Provider>,
        ),
      );
    }
  });
}
